<template>
  <div>
    <CreateSpecUpdateDialog
      :dialog="showCreateSpecUpdateDialog"
      @close="closeCreateSpecUpdateDialog"
    >
    </CreateSpecUpdateDialog>

    <v-card height="775px" style="position:relative;padding-bottom:50px">
      <v-toolbar
        color="grey darken-3"
        dark
        flat
      >
        <v-toolbar-title>Specifications</v-toolbar-title>
        <template v-slot:extension>
          <v-tabs
            v-model="tab"
            align-with-title
            background-color="transparent"
            grow
          >
            <v-tabs-slider color="red"></v-tabs-slider>

            <v-tab>Statistics</v-tab>
            <v-tab>Spec Releases</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <InstalledSpecs />
        </v-tab-item>
        <v-tab-item>
          <Specs ref="specsComponent"/>
        </v-tab-item>
      </v-tabs-items>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="grey lighten-1"
          @click.stop="openCreateSpecUpdateDialog()"
          v-if="tab === 1 && canShowCreateSpecUpdate"
        >
          Create Spec Update
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import InstalledSpecs from '../components/spec_updates/SpecsChart.vue';
import CreateSpecUpdateDialog from '../components/spec_updates/CreateSpecUpdateDialog.vue';
import Specs from '../components/spec_updates/Specs.vue';
import ConfirmDialog from "../components/ConfirmDialog.vue";

export default {
  components: {
    CreateSpecUpdateDialog,
    InstalledSpecs,
    Specs,
  },

  data() {
    return {
      tab: 0,
      showCreateSpecUpdateDialog: false,
    };
  },

  computed: {
    canShowCreateSpecUpdate() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin' ||
          this.$store.state.auth.token.user.role === 'engineer'
        )
      );
    },
  },

  methods: {
    openCreateSpecUpdateDialog() {
      this.showCreateSpecUpdateDialog = true;
    },

    closeCreateSpecUpdateDialog(newSpecUpdateCreated) {
      this.showCreateSpecUpdateDialog = false;
      if (newSpecUpdateCreated) {
        this.$refs.specsComponent.getData();
      }
    },
  },
};
</script>

<style scoped>
</style>
